export default __webpack_public_path__ + "static/media/search.30b22295.svg";